import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { initSeon } from "@nxplatform/helpers/vendors/seon";
import { useCeateRoutes } from "./routes/routes-hooks/platform-routes.hook.js";
initSeon();
const RouteSwitcher = ({
  layouts,
  Container,
  additionalLayouts,
  RootElement
}) => {
  const routes = useCeateRoutes(layouts, Container, additionalLayouts, RootElement);
  const router = createBrowserRouter(routes);
  return /* @__PURE__ */ jsx(RouterProvider, { router });
};
const _RouteSwitcher = memo(RouteSwitcher);
export {
  _RouteSwitcher as RouteSwitcher
};
